import service from './service';
import { UrlBuilder } from './url-builder';

const create = async (premise) => {
  const builder = new UrlBuilder(`/premises`);
  try {
    const response = await service.post(builder.toString(), premise);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error?.response?.data?.message;
  }
};

const update = async (premise) => {
  const builder = new UrlBuilder(`/premises/${premise._id}`);

  const response = await service.put(builder.toString(), premise);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

const remove = async (premise) => {
  const builder = new UrlBuilder(`/premises/${premise._id}`);

  const response = await service.remove(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

const countByPartner = async (partnerId, filter) => {
  if (!partnerId) return 0;

  const builder = new UrlBuilder(`/partners/${partnerId}/premises/count`);
  builder.add('companyId', filter?.companyId);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return 0;
};

const countByAdmin = async (filter) => {
  const builder = new UrlBuilder(`/admin/premises/count`);
  builder.add('companyId', filter?.companyId);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return 0;
};

const countByParent = async (parentId, filter) => {
  if (!parentId) return 0;

  const builder = new UrlBuilder(`/parents/${parentId}/premises/count`);
  builder.add('companyId', filter?.companyId);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return 0;
};

const listByPartner = async (partnerId, filters, page, pageSize) => {
  const builder = new UrlBuilder(`/partners/${partnerId}/premises`);
  builder.add('companyId', filters?.companyId);
  builder.add('name', filters?.name);
  builder.add('page', page);
  builder.add('pageSize', pageSize);
  builder.add('managers', 'true');
  builder.add('alertReceivers', 'true');

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return { items: [], length: 0, page: 0, pageSize: 10 };
};

const listByAdmin = async (filters, page, pageSize) => {
  const builder = new UrlBuilder(`/admin/premises`);
  builder.add('companyId', filters?.companyId);
  builder.add('name', filters?.name);
  builder.add('page', page);
  builder.add('pageSize', pageSize);
  builder.add('managers', 'true');
  builder.add('alertReceivers', 'true');

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return { items: [], length: 0, page: 0, pageSize: 10 };
};

const listAllByPartner = async (partnerId, filters) => {
  const builder = new UrlBuilder(`/partners/${partnerId}/premises`);
  builder.add('companyId', filters?.companyId);
  // builder.add('name', filters?.name);
  // builder.add('managers', 'true');
  // builder.add('alertReceivers', 'true');
  builder.add('mode', 'ALL');

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};

const listByCompany = async (companyId, filters, page, pageSize) => {
  const builder = new UrlBuilder(`/companies/${companyId}/premises`);
  builder.add('name', filters?.name);
  builder.add('managers', 'true');
  builder.add('alertReceivers', 'true');
  builder.add('page', page ?? 0);
  builder.add('pageSize', pageSize ?? 10);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};

const listManagedByCompany = async (companyId, filters, page, pageSize) => {
  const builder = new UrlBuilder(`/companies/${companyId}/managed-premises`);
  builder.add('name', filters?.name);
  builder.add('managers', 'true');
  builder.add('alertReceivers', 'true');
  builder.add('page', page ?? 0);
  builder.add('pageSize', pageSize ?? 10);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};

const listAllPremises = async (companyId) => {
  const builder = new UrlBuilder(`/companies/${companyId}/managed-premises?mode=all`);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};

const listAllByCompany = async (companyId, filters) => {
  const builder = new UrlBuilder(`/companies/${companyId}/premises`);
  builder.add('name', filters?.name);
  builder.add('mode', 'ALL');
  builder.add('isDesktop', true);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};

const listByParent = async (parentId, filter, page, pageSize) => {
  const builder = new UrlBuilder(`/parents/${parentId}/premises`);
  builder.add('companyId', filter?.companyId);
  builder.add('name', filter.name);
  builder.add('managers', 'true');
  builder.add('alertReceivers', 'true');
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};

const listAllByParent = async (parentId, filter) => {
  const builder = new UrlBuilder(`/parents/${parentId}/premises`);
  builder.add('companyId', filter?.companyId);
  builder.add('name', filter?.name);
  builder.add('managers', 'true');
  builder.add('alertReceivers', 'true');
  builder.add('mode', 'ALL');

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};

export const managerPremiseList = async (companyId, premiseId, page, pageSize) => {
  const builder = new UrlBuilder(`/company/${companyId}/premise/${premiseId}`);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};

export const premiseOfGeofences = async (premiseId) => {
  const builder = new UrlBuilder(`/premises/${premiseId}/geofence-list`);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};

export const checkAblityToCreateMasterGeofence = async (geofenceId) => {
  const builder = new UrlBuilder(`/master-geofence/${geofenceId}/check-range`);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};

export const saveMasterGeofence = async (payload) => {
  const builder = new UrlBuilder(`/master-geofence/save`);

  const response = await service.post(builder.toString(), payload);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

// export const getAllPremiseAsDistributorExcel = async (partnerId) => {
//   const builder = new UrlBuilder(`partners/${partnerId}/premises?mode=ALL`);

//   const response = await service.get(builder.toString());

//   if (response.status === 200) {
//     return response.data;
//   }

//   return [];
// };

export const getAllPremiseAsDistributorExcel = async (partnerId, companyFilter) => {
  const builder = new UrlBuilder(`/partners/${partnerId}/premises`);
  builder.add('companyId', companyFilter);
  builder.add('mode', 'ALL');

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};

const getAllPremiseAsAdminExcel = async (companyFilter) => {
  const builder = new UrlBuilder(`/admin/premises`);
  builder.add('mode', 'ALL');
  builder.add('companyId', companyFilter);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  create,
  countByPartner,
  countByParent,
  listByPartner,
  listByCompany,
  listManagedByCompany,
  listAllByPartner,
  listAllByCompany,
  listByParent,
  listAllByParent,
  remove,
  update,
  premiseOfGeofences,
  listAllPremises,
  countByAdmin,
  listByAdmin,
  getAllPremiseAsAdminExcel,
};
